<ng-container [ngSwitch]="display">
  <span [ngClass]="quantity > 1 ? 'font-size-small' : ''">
    <span class="price-plus" *ngIf="showAsAddition && price.regularAmount > 0">
      +
    </span>

    <span class="price-label" *ngIf="showPriceLabel">
      {{ 'i18n.price.price' | translate }}:
    </span>

    <span class="price-display" *ngSwitchCase="'hideOnZeroValue'"
           [ngClass]="[ price.reducedAmount === price.regularAmount ?
              '' : 'reduced']">
      <ng-template [ngIf]="price.regularAmount > 0">
        <ng-template [ngIf]="quantity > 1">
          <span [innerHTML]="'i18n.priceDisplay.times' | translate:quantity:{
                'pricePerUnit': pricePerUnit
              }"></span>:
          <span class="font-bold">
            {{ price.reducedAmount * quantity | priceFormat }}
          </span>
        </ng-template>
        <ng-template [ngIf]="quantity == 1">
          <span class="regular-price">
            {{ price.regularAmount | priceFormat }}
          </span>
          <span class="reduced-price">{{ price.reducedAmount | priceFormat }}
          </span>
        </ng-template>
      </ng-template>
    </span>

    <span class="price-display" *ngSwitchCase="'reducedAmountOnly'">
      {{ price.reducedAmount * quantity | priceFormat }}
    </span>

    <span class="price-display" *ngSwitchDefault
           [ngClass]="[price.reducedAmount === price.regularAmount ?
              '' : 'reduced']">
      <ng-template [ngIf]="quantity > 1">
        <span [innerHTML]="'i18n.priceDisplay.times' | translate:quantity:{
              'pricePerUnit': pricePerUnit
            }"></span>:
        <span class="font-bold">
          {{ price.reducedAmount * quantity | priceFormat }}
        </span>
      </ng-template>
      <ng-template [ngIf]="quantity == 1">
        <span class="regular-price">
          {{ price.regularAmount | priceFormat }}</span>
        <span class="reduced-price">{{ price.reducedAmount | priceFormat }}
        </span>
      </ng-template>
    </span>
  </span>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/core/price/price-display.component.html